<template>
    <div class="flex flex-col lg:flex-row gap-4">
        <div class="flex flex-col border-dashed lg:border-r-2 lg:pr-4 border-darkergrey">
            <h3 class="text-base md:text-2xl font-semibold text-lightblue mb-3">Genetic Test</h3>

            <div class="flex flex-col md:flex-row gap-4">
                <div class="flex flex-col gap-4 flex-1">
                    <p class="text-base text-lightblue text-center">Targeted sequencing</p>

                    <div
                        class="flex-1 border-solid rounded-xl border-t-20 border-lightblue bg-grey p-6 flex flex-col items-center gap-3"
                    >
                        <h5 class="text-base md:text-2xl font-light text-center">
                            Targeted Sequencing Analysis<sup>1-5</sup>
                        </h5>

                        <ul class="list-disc pl-4 font-light self-start">
                            <li>Targeted sequencing of <span class="italic">AGXT</span> coding region (exons) including deletion/duplication</li>
                            <li>Excludes promoter, non-coding, and coding mutations beyond specific base-pair size</li>
                            <li class="font-semibold">Utilized for PH1 diagnosis and cost-effective method for low number of targets</li>
                        </ul>
                    </div>

                    <div
                        class="flex-1 border-solid rounded-xl border-t-20 border-lightblue bg-grey p-6 flex flex-col items-center gap-3"
                    >
                        <ul class="list-disc pl-4 font-light self-start">
                            <li>
                                Targeted gene panels apply the targeted sequencing analysis approach across a variety of
                                related genes.<sup>3</sup> For example, a PH panel may cover all three forms of PH (<span class="italic">AGXT</span> [PH1],
                                <span class="italic">GRHPR</span> [PH2], <span class="italic">HOGA1</span> [PH3]).<sup>1</sup>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="flex flex-col gap-4 flex-1">
                    <p class="text-base text-lightblue text-center">Comprehensive genomic testing</p>

                    <div
                        class="flex-1 border-solid rounded-xl border-t-20 border-lightblue bg-grey p-6 flex flex-col items-center gap-3"
                    >
                        <h5 class="text-base md:text-2xl  font-light text-center">
                            Whole-Exome Sequencing<sup>1,3,6</sup>
                        </h5>

                        <ul class="list-disc pl-4 font-light self-start">
                            <li>Comprehensive screening of coding region across an entire gene</li>
                            <li>Broad mutation coverage, including larger base-pair insertions/deletions</li>
                            <li>
                                Currently more costly than targeted sequencing; infrequent outside of research settings
                            </li>
                        </ul>
                    </div>

                    <div
                        class="flex-1 border-solid rounded-xl border-t-20 border-lightblue bg-grey p-6 flex flex-col items-center gap-3"
                    >
                        <h5 class="text-base md:text-2xl  font-light text-center">
                            Whole-Genome Sequencing<sup>1,3,6</sup>
                        </h5>

                        <ul class="list-disc pl-4 font-light self-start">
                           
                            <li>Sequencing of all DNA, including coding, non-coding, and mitochondrial DNA</li>
                            <li>Ability to detect novel variations, including copy number variations</li>
                            <li>
                                Currently most expensive and time consuming; limited application in clinical practice
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex flex-col gap-4">
            <div class="flex flex-col flex-1">
                <h3 class="text-base md:text-2xl font-semibold text-lightblue mb-3">Enzymatic Test</h3>

                <p class="text-base text-lightblue text-center mb-4">Traditional assays</p>

                <div
                    class="border-solid rounded-xl border-t-20 border-lightblue bg-grey p-6 flex flex-col items-center gap-3"
                >
                    <h5 class="text-base md:text-2xl  font-light text-center">
                        Liver Biopsy<sup>1</sup>
                    </h5>

                    <ul class="list-disc pl-4 font-light self-start">
                        <li>
                            Measurement of AGT (PH1), GR (PH2), HOGA (PH3) enzyme activity in patients without an
                            identified pathogenic variant; method may be considered outdated in light of genetic testing
                            advances in recent years
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
